export default __webpack_public_path__ + "static/calidad-de-los-academicos-mobile-b7cf726e5da3ff3f0e258fb9366eab61.svg";